<ng-container *ngLet="langChange$ | async">
  @if (favoriteCatalogTitle) {
    <button [disabled]="disable" class="btn-empty btn-with-icon mb12" (click)="addFavoriteCatalog()">
      <app-hoverable-svg [class.element-disabled]="disable"
                         [icon]="favoriteCatalogIcon"
                         class="svg24 dark-gray-color mr8"
      ></app-hoverable-svg>
      <span [class.element-disabled]="disable" class="body-2 notifications-title inactive-color-70">
        {{favoriteCatalogTitle | translate }}
      </span>
    </button>
  }
  @if (subscribeCatalogTitle && !isDynamic && isRuLocale) {
    <button [disabled]="disable" class="btn-empty btn-with-icon" (click)="subscribeCatalog()">
      <app-hoverable-svg [class.element-disabled]="disable"
                         [icon]="subscribeCatalogIcon"
                         class="svg24 dark-gray-color mr8"
      ></app-hoverable-svg>
      <span [class.element-disabled]="disable" class="body-2 notifications-title inactive-color-70">
      {{ subscribeCatalogTitle | translate }}
    </span>
    </button>
  }
</ng-container>
